import { createSelector } from 'reselect';
import PreconResconConsignmentsSummaryColumns
  from '../../containers/PreconResconConsignmentsSummaryColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PRECON_RESCON_CONSIGNMENTS_SUMMARY
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PRECON_RESCON_CONSIGNMENTS_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.PRECON_RESCON_CONSIGNMENTS_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PreconResconConsignmentsSummaryColumns);
